@if (expiresAtMs && (!isExpired || !hideWhenExpired)) {
  <div class="slot-hold-timer">
    <span class="label">{{ label | translate }}</span>
    <span class="time">{{ display | numberTranslate }}</span>
  </div>
}
